export default "__VITE_ASSET__BfnNUSSx__"